import React, { useState, useEffect } from "react"
import {
  Modal,
  Typography,
  Button,
  message,
  InputNumber,
  DatePicker,
  Form,
} from "antd"
import _ from "underscore"
import moment from "moment"
import { disabledDate } from "../../utilities"
import SuccessPopup from "./SuccessPopup"

const { Text } = Typography

const ModalIndicator = ({
  indicatorDetails,
  visible,
  setVisible,
  indicatorNumber,
  getSingleIndicatorDetailsAction,
  indicatorIdSingle,
}) => {
  const [action, setAction] = useState("viewMode")
  const [goal, setGoal] = useState(null)
  const [targetDate, setTargetDate] = useState(null)
  const [showSuccessPopup, setShowSuccessPopup] = useState(false)

  const [form] = Form.useForm()

  useEffect(() => {
    if (_.isEmpty(indicatorDetails)) {
      setAction("editMode")
      setGoal(null)
      setTargetDate(null)
      form.resetFields()
    } else {
      setGoal(indicatorDetails.value)
      setTargetDate(
        indicatorDetails.target_completion_date
          ? moment(indicatorDetails.target_completion_date)
          : null,
      )
      setAction("viewMode")
    }
  }, [indicatorDetails, form])

  const handleCancel = () => {
    setVisible(false)
    setAction("viewMode")
    form.resetFields()
  }

  const handleEdit = () => {
    if (action === "editMode") {
      form
        .validateFields()
        .then(() => {
          const indicatorId = indicatorDetails.implementation_rubric_indicator_id
            || indicatorIdSingle

          APIClient.post(
            "/goals/upsert_goals",
            {
              goals: [
                {
                  implementation_rubric_indicator_id: indicatorId,
                  value: goal,
                  target_completion_date: targetDate.format("YYYY-MM-DD"),
                },
              ],
            },
            () => {
              getSingleIndicatorDetailsAction(indicatorId)
              // message.success("Saved");
              setShowSuccessPopup(true)

              setVisible(false)
              setShowSuccessPopup(true)
              setAction("viewMode")
              form.resetFields()
            },
            (error) => {
              console.error("Error upserting goals:", error)
              message.error("Failed to save data.")
            },
          )
        })
        .catch((error) => {
          console.error("Validation failed:", error)
        })
    } else {
      setAction("editMode")
    }
  }

  return (
    <>
      <Modal
        centered
        closeIcon={false}
        title={(
          <Text strong>
            <span className="default-font">
              {_.isEmpty(indicatorDetails)
                ? "Set Indicator Goal"
                : action === "viewMode"
                  ? "View Indicator Goal"
                  : "Edit Indicator Goal"}
            </span>
          </Text>
        )}
        visible={visible}
        onCancel={handleCancel}
        footer={[
          <Button key="cancel" className="closeIndBtns" onClick={handleCancel}>
            Close
          </Button>,
          <Button key="edit" className="editIndModalBtns" onClick={handleEdit}>
            {action === "viewMode" ? "Edit" : "Save"}
          </Button>,
        ]}
      >
        <div className="default-font fontSize16">
          <p>
            <Text strong>Indicator Number:</Text> {indicatorNumber}
          </p>

          <Form form={form} layout="vertical">
            {action === "viewMode" && !_.isEmpty(indicatorDetails) ? (
              <>
                <p>
                  <Text strong>Selected Goal:</Text> {indicatorDetails.value}
                </p>
                <p>
                  <Text strong>Target Date:</Text>{" "}
                  {moment(indicatorDetails.target_completion_date).format(
                    "MMMM D, YYYY",
                  )}
                </p>
              </>
            ) : (
              <>
                <Form.Item
                  label="Goal (0-4): "
                  name="goal"
                  initialValue={goal}
                  rules={[
                    {
                      required: true,
                      message: "Please input a goal value between 0 and 4",
                    },
                    {
                      type: "number",
                      min: 0,
                      max: 4,
                      message: "Goal must be between 0 and 4",
                    },
                  ]}
                >
                  <InputNumber
                    style={{ width: "100%" }}
                    min={0}
                    max={4}
                    value={goal}
                    onChange={(value) => setGoal(value)}
                  />
                </Form.Item>
                <Form.Item
                  label="Target Date: "
                  name="targetDate"
                  initialValue={targetDate}
                  rules={[
                    { required: true, message: "Please select a target date" },
                  ]}
                >
                  <DatePicker
                    style={{ width: "100%" }}
                    value={targetDate}
                    onChange={(date) => setTargetDate(date)}
                    format="YYYY-MM-DD"
                    disabledDate={disabledDate}
                  />
                </Form.Item>
              </>
            )}
          </Form>
        </div>
      </Modal>
      <SuccessPopup
        visible={showSuccessPopup}
        onClose={() => {
          setShowSuccessPopup(false)
          setVisible(false)
        }}
      />
    </>
  )
}

export default ModalIndicator
